import { EntityConfig } from "../../../..";


export const CNCConfig : EntityConfig = [
    {
        id: 'id',
        label: 'Id',
        nonEditable: true,
        hidden: true,
        type: 'id'

      },
    {
        id: 'observacoes',
        label: 'Observações',
        type: 'text',
    },
    {
        id: 'isExternal',
        label: 'Operação externa',
        type: 'boolean',
        filterable: true,
    },
    {
        id: 'dataExpedicao',
        label: 'Data de saída',
        type: 'date',
        conditional : (form : any)  => form?.isExternal 
    }


]